import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/college-savings',
  component: () => import('../../routes/CollegeSavings.svelte'),
  card: {
    id: 'college-savings',
    title: 'College Savings',
    description:
      'Plan for your child\'s education. Calculate how much to save monthly in a 529 plan to cover projected college costs with tax-free growth.',
    icon: 'school',
    iconBgClass: 'bg-indigo-50',
    iconTextClass: 'text-indigo-600',
    href: '/college-savings',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'College Savings Calculator – 529 Plan Growth & Education Cost Calculator',
    description:
      'Free college savings calculator to plan your 529 plan contributions. Calculate how much you need to save monthly to cover projected college costs with tax-free investment growth. Includes year-by-year breakdown.',
  },
};

export default meta;
